import update from 'react-addons-update';
import {AppSettings} from '../../../settings';
import {reportUpdateMapper} from './my-reports.mappers';

export const getInitialState = () => ({
  searchTerm: undefined,
  filterByCreatorActive: 'ALL',
  loading: false,
  loadedAmount: 0,
  total: 0,
  data: {}
});

export const myReportsReducers = (state = getInitialState(), action) => {
  switch (action.type) {
    case 'RESET_MY_REPORTS': {
      return getInitialState();
    }

    case 'UPDATE_CREATOR_BY_FILTER': {
      return update(state, {
        data: {$set: {}},
        total: {$set: 0},
        filterByCreatorActive: {$set: action?.payload?.filterBy},
        loadedAmount: {$set: 0},
        loading: {$set: false}
      });
    }

    case 'LOAD_REPORTS': {
      return update(state, {
        data: {$merge: action?.payload?.data},
        total: {$set: action?.payload?.total},
        loadedAmount: {
          $apply: v => {
            const nextStartPage = v + AppSettings.paginationSize;
            return nextStartPage > state.total && state.total > 0 ? state.total : nextStartPage;
          }
        },
        loading: {$set: false}
      });
    }

    case 'UPDATE_REPORT': {
      if (action.payload.status !== 'DELETED_DOCUMENTS') {
        const payload = reportUpdateMapper(action.payload);
        return update(state, {data: {$merge: {[payload.unique_id]: {...state.data[payload.unique_id], ...payload}}}});
      }

      const documentsToDelete = action.payload.deleted_documents || [];
      const data = {};
      Object.keys(state.data).forEach(docId => {
        const document = {...state.data[docId]};
        data[docId] = document;

        if (documentsToDelete.includes(docId)) {
          data[docId] = {...document, deleted: true};
        }
      });

      return update(state, {data: {$set: data}});
    }

    case 'LOADING_REPORTS': {
      return update(state, {loading: {$set: action.payload}});
    }

    case 'SEARCH_REPORTS': {
      return update(state, {searchTerm: {$set: action.payload}});
    }

    default:
      return state;
  }
};
